/**
 * Typed access to Vite environment variables. Throws early if a required
 * variable is missing so we fail loudly at app boot rather than mid-request.
 */

function required(name: string, value: string | undefined): string {
  if (!value) {
    throw new Error(`Missing required environment variable: ${name}`);
  }
  return value;
}

export const env = {
  clerkPublishableKey: required(
    "VITE_CLERK_PUBLISHABLE_KEY",
    import.meta.env.VITE_CLERK_PUBLISHABLE_KEY,
  ),
  apiBaseUrl: required("VITE_API_BASE_URL", import.meta.env.VITE_API_BASE_URL),
  isDev: import.meta.env.DEV,
} as const;
